import axios, { Axios } from "axios";
import * as cm from './CookieManagement';
import React from "react";
//const baseURLDir = "http://192.168.178.67:8082";
//const baseURLDir = "http://localhost:8082";
const baseURLDir = "";
const baseURL = baseURLDir + "/api.php";

const PENDING = 0;

const IN_QUEUE = 1;
const IN_PROGRESS = 2;
const FINISHED = 3;

function getStaticFile(filename){
    return baseURLDir + "/static/" + filename
}

function addJob(url, type, lang,callback) {
    let formdata = new FormData();
    formdata.append("url", url);
    formdata.append("type", type);
    if(lang != null)
        formdata.append("lang",lang);
    axios.post(
        baseURL + "?action=addJob",
        formdata
    ).then(res => callback(res.data));
}

function getClipInformation(url, callback){
    let formdata = new FormData();
    formdata.append("url", url);
        axios.post(
        baseURL + "?action=getClipInformation",
        formdata
    ).then(res => callback(res.data));
}

function getJobs(callback) {
    axios.get(baseURL + "?action=getQueue")
        .then(res => {if(!res.access_denied) callback(res.data)});
}

function getStatus(status_code) {
    let status = {
        0: <span className="status-pending">Pending</span>,
        1: <span className="status-in-queue">In queue</span>,
        2: <span className="status-in-progress">In progress</span>,
        3: <span className="status-finished">Finished</span>
    }
    return status[status_code];
}

function removeJob(id, callback = (json) => { }) {
    let formdata = new FormData();
    formdata.append("id", id);
    axios.post(
        baseURL + "?action=removeJob",
        formdata
    ).then(res => callback(res.data));
}

function renewClipExpiration(id, callback = (json) => { }) {
    let formdata = new FormData();
    formdata.append("id", id);
    axios.post(
        baseURL + "?action=renewClipExpiration",
        formdata
    ).then(res => callback(res.data));
}

function checkLogin(callback) {
    axios.get(baseURL + "?action=checkSession").then(
        res => callback(res.data)
    );
}

function checkAutologin(callback) {
    axios.get(baseURL + "?action=autologin").then(
        res => callback(res.data)
    );
}

function login(password, remember, callback) {
    let formdata = new FormData();
    formdata.append("password", password);
    formdata.append("remember", remember ? "true" : "false");
    axios.post(
        baseURL + "?action=login",
        formdata
    ).then(
        res => { return callback(res.data) }
    );
}

function createSession(uid, callback) {
    axios.get(baseURL + "?action=createSession&uid=" + uid).then(
        (res) => callback(res.data.success));
}

function storeMailAddress(mail) {
    let formdata = new FormData();
    formdata.append("mail", mail);
    axios.post(baseURL + "?action=storeMailAddress", formdata);
}

function sendJobList(mail, callback = (json) => { }) {
    let formdata = new FormData();
    formdata.append("mail", mail);
    axios.
        post(baseURL + "?action=sendJobList", formdata)
        .then(res => callback(res.data));
}

function cleanMediaBookmarksInLocalStorage(rows){
   let mediaBookmarks = cm.loadFromLocalStorage("mediaBookmarks")
   if(mediaBookmarks==null)
    return;
   for(const mediaId of Object.keys(mediaBookmarks)){
      if(!rows.some((row) => row.id===mediaId))
        
        delete mediaBookmarks[mediaId];
   }

   cm.saveToLocalStorage("mediaBookmarks", mediaBookmarks);






}

export {getStaticFile,renewClipExpiration,cleanMediaBookmarksInLocalStorage,checkAutologin, addJob, getStatus, getJobs, removeJob, checkLogin, login, createSession, storeMailAddress, sendJobList,getClipInformation, PENDING, IN_QUEUE, IN_PROGRESS, FINISHED }